import React from 'react';
import DocumentationSidebar from '../documentation/component/DocumentationSidebar';
import { useDocImage } from './hooks/useDocImage';
import { useTranslation } from 'react-i18next';




export default function ActivityLog() {
    const { t } = useTranslation();
    const image001 = useDocImage('activitylogs-img', 'image-0001.png');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>{t('documentation.activityLogs.title')}</h1>
                            <p className='header-para'>{t('documentation.activityLogs.intro')}</p>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.activityLogs.table.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.activityLogs.table.intro')}</p>
                                    <ul>
                                        <img src={image001} alt={t('documentation.activityLogs.table.imageAlt')} className='img-fluid pt-10 pb-20' />
                                        <li>{t('documentation.activityLogs.table.columns.message')}</li>
                                        <li>{t('documentation.activityLogs.table.columns.action')}</li>
                                        <li>{t('documentation.activityLogs.table.columns.addedBy')}</li>
                                        <li>{t('documentation.activityLogs.table.columns.dateTime')}</li>
                                    </ul>
                                    <p className='mb-0'>
                                        {t('documentation.activityLogs.table.note')}
                                    </p>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.activityLogs.pagination.title')}
                                </div>
                                <div className="card-body">
                                    <ul>
                                        <li>{t('documentation.activityLogs.pagination.rowsPerPage')}</li>
                                        <li>{t('documentation.activityLogs.pagination.rangeTotal')}</li>
                                        <li>{t('documentation.activityLogs.pagination.navigation')}</li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
